import request from '@/utils/axios'

// 首页轮播图
export function advertiseList() {
  return request({
    url: '/information/bannerList',
    method: 'post',
    data: {
      type: 'PC'
    }
  })
}

// 首页轮播图详情
export function advertiseView(query) {
  return request({
    url: `${process.env.VUE_APP_ADMIN_API}/cms/carousel/view`,
    method: 'get',
    params: query
  })
}

// 首页 APP 下载链接
export function fetchAPPDownloadLinks() {
  return request({
    url: '/information/webAppVersion',
    method: 'post'
  })
}
